import { useEffect } from 'react';

function FontInitializer() {
  useEffect(() => {
    // Load Nunito Sans font from Google Fonts with specific weights
    // 300 (Light) for body text
    // 500 (Medium) for subheadings
    // 600 (Semi-Bold) for headings
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Apply Nunito Sans as the default font
    document.documentElement.style.setProperty('--font-body', '"Nunito Sans", -apple-system, BlinkMacSystemFont, sans-serif');
    document.documentElement.style.setProperty('--font-heading', '"Nunito Sans", -apple-system, BlinkMacSystemFont, sans-serif');
  }, []);

  return null;
}

export default FontInitializer;
